import DragonKitIntroduction from "../components/DragonKit/DragonKitIntroduction.vue";
import DragonKitContents from "../components/DragonKit/DragonKitContents.vue";
import DragonKitRequiredMaterials from "../components/DragonKit/DragonKitRequiredMaterials.vue";
import DragonKitBasicSetupAndRegistration from "../components/DragonKit/DragonKitBasicSetupAndRegistration.vue";
import DragonKitBasicInstallationCeilingMount from "../components/DragonKit/DragonKitBasicInstallationCeilingMount.vue";
import DragonKitCreateWorkingSpace from "../components/DragonKit/DragonKitCreateWorkingSpace.vue";
import DragonKitTrackingPage from "../components/DragonKit/DragonKitTrackingPage.vue";
import DragonKitRegisteringTag from "../components/DragonKit/DragonKitRegisteringTag.vue";
import DragonKitChangingHeight from "../components/DragonKit/DragonKitChangingHeight.vue";

// Add a group here, then list its pages inside `pages`.
// Group IDs and page keys must be unique across this file.
export default [
  {
    id: 'dragon-kit',
    label: 'Dragon Promo Kit Quick Start Guide',
    pages: [
      { key: '1-1', title: 'Introduction', component: DragonKitIntroduction },
      { key: '1-2', title: 'Dragon Promo Kit Contents', component: DragonKitContents },
      { key: '1-3', title: 'Required Materials', component: DragonKitRequiredMaterials },
      { key: '1-4', title: 'Basic Setup and Registration', component: DragonKitBasicSetupAndRegistration },
      { key: '1-5', title: 'Basic Installation for Ceiling Mount', component: DragonKitBasicInstallationCeilingMount },
      { key: '1-6', title: 'Basic Setup to create a Working Space', component: DragonKitCreateWorkingSpace },
      { key: '1-7', title: 'Tracking page', component: DragonKitTrackingPage },
      { key: '1-8', title: 'Registering a Tag', component: DragonKitRegisteringTag },
      { key: '1-9', title: 'Changing the Height', component: DragonKitChangingHeight }
    ]
  }
];
